import styled from 'styled-components';

export const TabsContainer = styled.div`
  flex: none;
  margin-bottom: 0;
`;
